import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BasicRangeShortcuts from '../date-range-picker/BasicRangeShortcuts';
import { FormControl, Select, MenuItem, Button } from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { PenIcon } from 'lucide-react';
import CreateCampaignModal from './CreateCampaignModal.js';
import { setDateFilter } from '../../containers/app-container/reducer/filterSlice';

const SearchFilter = ({
    type,
    onStatusChange,
    selectedStatus,
    selectedSources,
    onSourceChange,
    onCreateCampaign,
    sourceOptions = [],
    statusOptions = [],
}) => {
    const dispatch = useDispatch();
    const defaultDateRange = useSelector((state) => state.filter.defaultDateRange);
    const [isCreateCampaign, setIsCreateCampaign] = React.useState(false);
    const columnHeaders = sourceOptions.map((item) => ({
        key: item.label,
        label: item.label,
    }));
    const selectedSourceLabel =
        selectedSources.length === 0
            ? 'All Source'
            : selectedSources.length === 1
                ? selectedSources[0]
                : `${selectedSources[0]} +${selectedSources.length - 1}`;
    const handlClickCreateModal = () => {
        setIsCreateCampaign(true)
    }
    const handleCloseCreateModal = () => {
        setIsCreateCampaign(false)
    }

    const handleSourceChange = (key) => {
        if (selectedSources.includes(key)) {
            onSourceChange(selectedSources.filter(item => item !== key));
        } else {
            onSourceChange([...selectedSources, key]);
        }
    };
    return (
        <>
            <div className="d-flex gap-2 justify-content-between align-items-center py-16">

                <Button onClick={handlClickCreateModal} sx={{ background: '#BE1F1F', color: '#fff', padding: '12px 20px', borderRadius: '8px', fontFamily: "Neue Montreal", textTransform: 'capitalize', fontSize: '16px', fontWeight: '500' }}>
                    Create Campaigns  <span style={{ borderLeft: '1px solid #FFFFFF7A', padding: '0 12px', marginLeft: '12px' }}> <PenIcon /> </span>
                </Button>

                <div className="d-flex gap-2 justify-content-between align-items-center">
                    {type !== 'chat' ? <>
                        <BasicRangeShortcuts id="range1" />

                        {/* //status filter */}
                        <FormControl
                            size="small"
                            sx={{
                                minWidth: 120,
                                boxShadow: 'none',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    background: '#f3f4f6',
                                    boxShadow: 'none',
                                    '& fieldset': {
                                        borderColor: '#d1d5db', // Default border color
                                        borderWidth: '1px',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#9ca3af', // Hover border color (gray-400)
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ff4A4A', // Focused border (blue-600)
                                        borderWidth: '1.5px',
                                    },
                                },
                            }}
                        >
                            <Select
                                value={selectedStatus || ''}
                                onChange={(e) => onStatusChange(e.target.value)}
                                IconComponent={KeyboardArrowDownOutlinedIcon} // custom arrow icon
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected) return "All Status";
                                    return selected.charAt(0).toUpperCase() + selected.slice(1);
                                }}
                                sx={{
                                    fontSize: '14px',
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '8px 12px',
                                        fontSize: '14px',
                                        fontFamily: "Neue Montreal",
                                    },
                                    fontFamily: "Neue Montreal",
                                }}
                            >
                                <MenuItem value="" sx={{ fontSize: '14px', fontFamily: "Neue Montreal", }}>
                                    All Status
                                </MenuItem>
                                {statusOptions.map((status) => (
                                    <MenuItem key={status.key} value={status.key} sx={{ fontSize: '14px', fontFamily: "Neue Montreal", }}>
                                        {status.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* //source filter */}
                        <div className="d-flex align-items-center gap-2">

                            <div className="dropdown">

                                <Button type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false" sx={{
                                        minWidth: 120,
                                        boxShadow: 'none',
                                        border: '1px solid rgb(209, 213, 219)',
                                        background: '#f3f4f6',
                                        borderRadius: '6px', padding: '6px 10px', fontFamily: "Neue Montreal", color: '#000000de', textTransform: 'capitalize', fontSize: '14px', fontWeight: '400', textAlign: 'left',
                                    }}>
                                    {selectedSourceLabel} <KeyboardArrowDownOutlinedIcon />
                                </Button>

                                <ul className="dropdown-menu manage-list" style={{ padding: '0' }}>
                                    {columnHeaders.map((column) => (
                                        <li
                                            key={column.key}
                                            className="dropdown-item d-flex align-items-center gap-1"
                                            style={{ fontSize: '14px' }}
                                        >
                                            <input
                                                className="form-check-input"
                                                style={{ width: '17px', height: '17px' }}
                                                type="checkbox"
                                                checked={selectedSources.includes(column.key)}
                                                onChange={() => handleSourceChange(column.key)}
                                            />
                                            {column.label}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <Button
                            className=""
                            sx={{
                                textTransform: 'capitalize',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#000000de',
                                height: '40px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db', // light gray border
                                backgroundColor: '#fff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#BE1F1F', // blue hover
                                    color: '#fff', // white text on hover
                                    borderColor: '#ff4A4A', // blue border
                                },
                                fontFamily: "Neue Montreal",
                            }}

                            onClick={() => {
                                onStatusChange('');
                                onSourceChange([]);
                                dispatch(setDateFilter({ dateRange: defaultDateRange }));
                            }}

                        >
                            Reset
                        </Button></> : null}
                </div>

            </div>

            <CreateCampaignModal
                open={isCreateCampaign}
                onClose={handleCloseCreateModal}
                onSubmit={onCreateCampaign}
                sourceOptions={sourceOptions}
            />
        </>
    );
};

export default SearchFilter; 
